import IDocumentType from '../interfaces/IDocumentType';

const documentTypes: IDocumentType[] = [
	{
		tag: 'general_communication',
		name: 'general_communication',
	},
	{
		tag: 'tax_legal_and_fund_rules',
		name: 'tax_legal_and_fund_rules',
	},
	{
		tag: 'subscriptions',
		name: 'subscriptions',
	},
	{
		tag: 'periodic_report',
		name: 'periodic_report',
	},
	{
		tag: 'monthly_report',
		name: 'monthly_report',
	},
	{
		tag: 'annual_report',
		name: 'annual_report',
	},
	{
		tag: 'ampere_report',
		name: 'ampere_report',
	},
	{
		tag: 'capital_call_and_distribution_notices',
		name: 'capital_call_and_distribution_notices',
	},
	{
		tag: 'consultation',
		name: 'consultation',
	},
	{
		tag: 'capital_account_statement',
		name: 'capital_account_statement',
	},
	{
		tag: 'esg_reports',
		name: 'esg_reports',
	},
	{
		tag: 'mandate',
		name: 'mandate',
	},
];

const useDocumentTypes = () => {
	const isFetching = false;

	return {
		isFetching,
		documentTypes: documentTypes,
	};
};

export default useDocumentTypes;
